import React from 'react'
import { Button } from '@chakra-ui/react'
import { useCallback, useState } from 'react'
import { createContext, useContext } from 'react'
import { REPOSITORY } from './../../../api/repository/Repository'
import { useLoadingContext } from './LoadingContext'
import { useRequestStatusContext } from './RequestStatusContext'

export const DeleteRefillContext = createContext({})

export const useDeleteRefillContext = () => {
  const value = useContext(DeleteRefillContext)

  return value
    ? {
        ...value,
      }
    : null
}

export const useDeleteRefillConfirm = (refresh) => {
  const [isOpenConfirm, setIsOpenConfirm] = useState(false)
  const [nAsignacion, setNAsignacion] = useState(null)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const onOkStatus = useCallback(
    (response) => {
      handleCLoseLoading()
      handleSetTitle(response.data.sMensaje, response.status)
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          {response.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpen()
    },
    [handleCLoseLoading, handleChangeBody, handleOpen, handleSetTitle],
  )

  const onErrorStatus = useCallback(
    (error) => {
      handleCLoseLoading()
      handleSetTitle(error.response.data.error, error.response.status)
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpen()
    },
    [handleCLoseLoading, handleChangeBody, handleOpen, handleSetTitle],
  )
  const handleOpenConfirm = useCallback(
    (nAsignacion) => {
      setIsOpenConfirm(true)
      setNAsignacion(nAsignacion)
    },
    [nAsignacion],
  )
  const handleCloseConfirm = useCallback(() => {
    setIsOpenConfirm(false)
    setNAsignacion(null)
  }, [])

  const handleOnConfirm = useCallback(
    async (user) => {
      //Se extrae user del localstorage ya que se quitó el login para eliminar recarga
      const userData = localStorage.getItem("currentUser");
      const userObject = JSON.parse(userData);
      user = userObject.sUsuario;
      //
      handleOpenLoading()
      await REPOSITORY.wsEmpresa.refills
        .declineRefill(user, nAsignacion)
        .then((res) => {
          handleCloseConfirm()
          refresh()
          onOkStatus(res)
        })
        .catch((error) => {
          handleCloseConfirm()
          onErrorStatus(error)
        })
    },
    [nAsignacion],
  )
  return {
    isOpenConfirm,
    handleOpenConfirm,
    handleCloseConfirm,
    handleOnConfirm,
  }
}
